import { BCPieChart } from '@bimser/components';
import { FormItemTypes } from '@bimser/core';
import { JSX } from 'react';
import Chart from '../Chart';

export default class PieChart extends Chart {
	constructor() {
		super();
		this.controlType = FormItemTypes.EControlTypes.PieChart;
	}

	__render(): JSX.Element {
		let verticalAlignment: 'top' | 'bottom';
		let horizontalAlignment: 'left' | 'right';

		if (this.legend.position === 'top' || this.legend.position === 'bottom') {
			verticalAlignment = this.legend.position;
		} else if (this.legend.position === 'left' || this.legend.position === 'right') {
			horizontalAlignment = this.legend.position;
		}

		return super.__render(
			<BCPieChart.Components.PieChart
				dataSource={this.data}
				title={this.title.getText()}
				style={this.style}
				onPointClick={this.__onClickSeriesItem}
			>
				{this.charts.map(chart => {
					return (
						<BCPieChart.Components.Series
							selectionMode="onlyPoint"
							argumentField={chart.argumentField}
							valueField={chart.valueField}
							hoverMode={!this.hover.enabled ? 'none' : undefined}
							name={chart.name}
							key={chart.name}
						/>
					);
				})}

				<BCPieChart.Components.Tooltip
					enabled={this.tooltip.enabled}
					zIndex={2000}
				/>

				<BCPieChart.Components.Animation enabled={this.animation.enabled} />

				<BCPieChart.Components.Legend
					visible={this.legend.enabled}
					verticalAlignment={verticalAlignment}
					horizontalAlignment={horizontalAlignment}
				/>
			</BCPieChart.Components.PieChart>
		);
	}
}
